<template>
  <div>
    <div class="sc-CB">
      <button class="sc-btn" title="拖拽调整位置，点击展开或收起" aria-label="拖拽调整位置，点击展开或收起" @click="boxRotate">
        <span class="sc-block">
          <span :class="rotateFlag?'sc-block-span3':''" class="sc-block-span1"></span>
          <span class="sc-block-span2"></span>
        </span>
      </button>
      <transition name="sc-menu1">
        <div class="sc-menu1" @click="onCustomer()" v-if="rotateFlag">
          <i class="el-icon-chat-dot-round"></i>
          <div class="menu2-info">
            <div class="menu2-left">
              <i class="el-icon-chat-dot-round" style="margin:60% 0 0 30%;"></i>
            </div>
            <div class="menu2-right">
              <ul style="margin-top: 20px;">
                <li>联系客服</li>
              </ul>
            </div>
          </div>
        </div>
      </transition>
      <transition name='sc-menu2'>
        <div class="sc-menu2" v-if="rotateFlag">
          <i class="el-icon-phone-outline"></i>
            <div class="menu2-info">
              <div class="menu2-left">
                <i class="el-icon-phone-outline" style="margin:60% 0 0 30%;"></i>
              </div>
              <div class="menu2-right">
                <ul style="margin-top: 20px;">
                  <li>客服电话</li>
                  <li>400 088 3316</li>
                </ul>
              </div>
            </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    friendUid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      rotateFlag:false,
      rotate:{
        transform:'rotate(0deg)'
      }
    };
  },
  methods: {
    boxRotate(){
      this.rotateFlag = !this.rotateFlag
    },
    onCustomer() {
      let routeUrl = this.$router.resolve({path: '/chat', query: {friendUid: this.friendUid}})
      window.open(routeUrl.href, '_blank');
    }
  },
};
</script>

<style lang="scss" scoped>
.menu2-info{
  display: none;
  width: 190px;
  height: 90px;
  position: absolute;
  top: 75px;
  right: 60px;
  border-radius: 5px;
  background-color: #ffffff;
}
 .sc-menu2:hover .menu2-info{
   display: block;
   box-shadow: 0px 4px 12px 0px rgba(0, 0, 0,0.2);
 }
 .menu2-info::before {
     content: ' ';
     width: 0;
     height: 0;
     border: 8px solid transparent;
     border-left-color: #ffffff;
     position: absolute;
     left: 100%;
     top: 85%;
     margin-top: -15px;
 }
 .menu2-left,.menu2-right{
    float: left;
    height: 150px;
 }
 .menu2-left{
   width: 50px;
 }
 .menu2-right{
   width: 140px;
    li {
     width: 100px;
     height: 20px;
     text-align: left;
     margin: 0 0 8px 10px;
   }
 }
.el-icon-chat-dot-round,.el-icon-phone-outline{
  font-size: 25px;
  margin: 22%;
 }
.sc-CB{
  width: 50px;
  height: 50px;
  margin-top: 10px;
  position: relative;
}
.sc-menu1,.sc-menu2{
  background-color: white;
}
.sc-menu1-enter-active,.sc-menu1-leave-active{
  transition: all 0.3s;
}
.sc-menu1-enter,.sc-menu1-leave-to{
    opacity:0;
    transform: translateY(-50px) scale(0.1);
  }
.sc-menu2-enter-active,.sc-menu2-leave-active{
  transition: all 0.3s;
}
.sc-menu2-enter,.sc-menu2-leave-to{
    opacity:0;
    transform: translateY(-50px) scale(0.1);
  }
.sc-btn{
  background-color: #0064C8;
}
.sc-btn,.sc-menu1,.sc-menu2{
  width: 45px;
  height: 45px;
  margin: 10px 2.5px 0 2.5px;
  border-radius: 50%;
}
.sc-block{
  width: 23px;
  height: 23px;
  text-align: center;
  line-height: 0px;
  display: inline-block;
  margin-top: 5px;
}
.sc-block-span1::before,.sc-block-span1::after,.sc-block-span2::before,.sc-block-span2::after{
  content: '';
  width: 7px;
  height: 7px;
  border: 1px solid white;
  display: inline-block;
  margin: 1px;
  transition: all 0.3s ease;
}
.sc-block-span3::after{
  transform: rotate(45deg);
}
.el-icon-phone-outline:hover{
   transform: scale(1.1);
   margin: 23%;
 }
</style>



// WEBPACK FOOTER //
// customerSer.vue?1073a5bc